import { Injectable, signal } from '@angular/core';

/**
 * OPS-03-T01: whether the browser reports a connection. The offline banner and the replay of the offline queue both read this
 * one signal instead of each screen polling `navigator.onLine`.
 */
@Injectable({ providedIn: 'root' })
export class ConnectivityService {
  private readonly onlineSignal = signal(typeof navigator === 'undefined' ? true : navigator.onLine);
  /** The browser's last report. Being online is not proof the API answers; a failed call is retried by the queue itself. */
  readonly online = this.onlineSignal.asReadonly();

  constructor() {
    if (typeof window === 'undefined') return;
    window.addEventListener('online', () => this.onlineSignal.set(true));
    window.addEventListener('offline', () => this.onlineSignal.set(false));
  }
}
